module.exports = "/fonts/vendor/typeface-open-sans/files/open-sans-latin-800italic.woff?92da6f116d973bd334cf9b3afdb29c4f";